/**
 * @file Generic Badge component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  badgeStyle: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'success-vibrant',
    'info',
    'warning',
    'danger',
    'glass',
    'link',
    'reset',
    'yellow',
    'dark-transparent',
    'dark-transparent-light',
    'purple',
    'orange',
  ]),
  badgeSize: PropTypes.oneOf(['xs', 'sm', 'lg']),
  round: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

const Badge = ({
  badgeStyle = 'primary',
  badgeSize,
  className,
  round,
  children,
  ...props
}) => {
  const classes = classNames({
    badge: true,
    [`badge-${badgeStyle}`]: !!badgeStyle,
    [`badge-${badgeSize}`]: badgeSize,
    'badge-round': round,
    [className]: className,
  });

  return (
    <span className={classes} {...props}>
      {children}
    </span>
  );
};

Badge.propTypes = propTypes;

export default Badge;
